const stripMargin = (template, ...expressions) =>
  template
    .reduce((accumulator, part, i) => {
      return accumulator + expressions[i - 1] + part
    })
    .replace(/\r?(\n)\s*\|/g, '$1')

export { stripMargin }
